/**
 * Mobile navigation (≤1000px): the new menu (snippets/km-mobile-menu.liquid), the homepage
 * "Shop by category" grid (sections/section-kiraana-mobile-home.liquid) and the header search pill.
 * The delivery line and zipcode sheet are driven by zipcode-handler.js.
 */
(function() {
  'use strict';

  var mobile = window.matchMedia('(max-width: 1000px)');
  var menu = null;
  var closeTimer = null;

  function getMenu() {
    if (menu) return menu;
    menu = document.querySelector('[data-km-mobile-menu]');
    // Live on <body> so the sticky header can't clip or offset it
    if (menu && menu.parentNode !== document.body) document.body.appendChild(menu);
    return menu;
  }

  function selectGroup(index) {
    var m = getMenu();
    if (!m) return;
    index = String(index);
    m.querySelectorAll('[data-km-mm-group]').forEach(function(btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-km-mm-group') === index);
    });
    m.querySelectorAll('[data-km-mm-panel]').forEach(function(panel) {
      panel.hidden = panel.getAttribute('data-km-mm-panel') !== index;
    });
    clearSearch();
  }

  function firstVisibleGroup() {
    var m = getMenu();
    var buttons = m ? m.querySelectorAll('[data-km-mm-group]') : [];
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].offsetParent !== null || getComputedStyle(buttons[i]).display !== 'none') {
        return buttons[i].getAttribute('data-km-mm-group');
      }
    }
    return '0';
  }

  function openMenu(groupIndex) {
    var m = getMenu();
    if (!m) return false;
    clearTimeout(closeTimer);
    m.hidden = false;
    document.documentElement.classList.add('km-mm-open');
    selectGroup(groupIndex !== undefined && groupIndex !== null ? groupIndex : (m.querySelector('[data-km-mm-group].is-active') ? m.querySelector('[data-km-mm-group].is-active').getAttribute('data-km-mm-group') : firstVisibleGroup()));
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { m.classList.add('is-open'); });
    });
    // Keyboard users land on the close button; taps don't get a focus ring
    var close = m.querySelector('.km-mm-close');
    if (close && document.documentElement.getAttribute('data-whatin') === 'keyboard') close.focus({ preventScroll: true });
    return true;
  }

  function closeMenu() {
    var m = getMenu();
    if (!m || m.hidden) return;
    m.classList.remove('is-open');
    document.documentElement.classList.remove('km-mm-open');
    closeTimer = setTimeout(function() { m.hidden = true; }, 300);
  }

  // Side-rail search: matching collections from every group
  function clearSearch() {
    var m = getMenu();
    if (!m) return;
    var input = m.querySelector('[data-km-mm-search]');
    var results = m.querySelector('[data-km-mm-results]');
    if (input && input.value) input.value = '';
    if (results) { results.hidden = true; results.innerHTML = ''; }
    m.classList.remove('is-searching');
  }

  function runSearch(term) {
    var m = getMenu();
    var results = m.querySelector('[data-km-mm-results]');
    term = term.trim().toLowerCase();
    if (!term) {
      results.hidden = true;
      results.innerHTML = '';
      m.classList.remove('is-searching');
      return;
    }
    var shipping = document.documentElement.classList.contains('km-ship-zip');
    var seen = {};
    var list = document.createElement('ul');
    list.className = 'km-mm-links';
    m.querySelectorAll('[data-km-mm-link]').forEach(function(link) {
      var name = link.getAttribute('data-km-mm-link');
      if (name.indexOf(term) === -1 || seen[link.href]) return;
      if (shipping && link.closest('.km-show-local')) return;
      seen[link.href] = true;
      var li = document.createElement('li');
      li.appendChild(link.cloneNode(true));
      list.appendChild(li);
    });
    results.innerHTML = '';
    if (list.children.length) {
      results.appendChild(list);
    } else {
      var empty = document.createElement('p');
      empty.className = 'km-mm-empty';
      empty.textContent = 'No categories match "' + term + '".';
      results.appendChild(empty);
    }
    results.hidden = false;
    m.classList.add('is-searching');
  }

  // Homepage "Shop by category" grid from the header's groups (#km-cat-groups)
  function buildCategoryGrid() {
    var grids = document.querySelectorAll('[data-km-cat-grid]');
    var source = document.getElementById('km-cat-groups');
    if (!grids.length || !source) return;
    var data;
    try { data = JSON.parse(source.textContent); } catch (e) { return; }

    grids.forEach(function(grid) {
      if (grid.children.length) return;
      if (data.seasonal) {
        var s = data.seasonal;
        var a = document.createElement('a');
        a.href = s.url;
        a.className = 'km-cat km-cat-seasonal ' + (s.scope || '');
        a.innerHTML = '<span class="km-cat-circle"><img alt="" width="32" height="32"></span><span class="km-cat-label"></span>';
        a.querySelector('.km-cat-circle').style.background = s.tint;
        a.querySelector('img').src = s.icon;
        a.querySelector('.km-cat-label').textContent = s.label;
        if (s.tag) {
          var tag = document.createElement('span');
          tag.className = 'km-cat-tag';
          tag.textContent = s.tag;
          a.querySelector('.km-cat-circle').appendChild(tag);
        }
        grid.appendChild(a);
      }
      (data.groups || []).forEach(function(g) {
        // The group's collection page; without one, the menu opens on the group
        var b;
        if (g.url) {
          b = document.createElement('a');
          b.href = g.url;
        } else {
          b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('data-km-open-group', g.index);
        }
        b.className = 'km-cat ' + (g.scope || '');
        b.innerHTML = '<span class="km-cat-circle"><img alt="" width="32" height="32"></span><span class="km-cat-label"></span>';
        b.querySelector('.km-cat-circle').style.background = g.tint;
        b.querySelector('img').src = g.icon;
        b.querySelector('.km-cat-label').textContent = g.label;
        grid.appendChild(b);
      });
    });
  }

  // Shipping banner card: "We ship to [zip]"
  function fillShipZip() {
    var zip = null;
    try { zip = JSON.parse(localStorage.getItem('shopify_zipcode') || 'null'); } catch (e) {}
    document.querySelectorAll('[data-km-ship-zip]').forEach(function(el) {
      el.textContent = zip && zip.zipcode ? zip.zipcode : 'you';
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target.closest) return;

    // Header menu button opens the new menu on mobile (desktop keeps the theme's)
    var navButton = e.target.closest('#header a[aria-controls="nav"]');
    if (navButton && mobile.matches && getMenu()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openMenu();
      return;
    }

    var groupTile = e.target.closest('[data-km-open-group]');
    if (groupTile) {
      e.preventDefault();
      openMenu(groupTile.getAttribute('data-km-open-group'));
      return;
    }
    if (e.target.closest('[data-km-open-menu]')) {
      e.preventDefault();
      openMenu();
      return;
    }
    if (e.target.closest('[data-km-mm-close]')) {
      e.preventDefault();
      closeMenu();
      return;
    }
    var groupButton = e.target.closest('[data-km-mm-group]');
    if (groupButton) {
      e.preventDefault();
      selectGroup(groupButton.getAttribute('data-km-mm-group'));
      return;
    }

  }, true);

  document.addEventListener('input', function(e) {
    if (e.target.matches && e.target.matches('[data-km-mm-search]')) runSearch(e.target.value);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });

  // Leaving mobile width with the menu open
  mobile.addEventListener('change', function(e) { if (!e.matches) closeMenu(); });
  window.addEventListener('km:zipcode-change', fillShipZip);

  // Phones: the theme's real search form (#search, with its live search) sits in the header
  // strip as the search pill; on desktop it goes back to its place in the header row.
  var searchHome = null;
  function placeSearch() {
    var form = document.getElementById('search');
    var strip = document.querySelector('.km-mob-strip .km-mob-row');
    if (!form || !strip) return;
    if (mobile.matches) {
      if (form.parentNode === strip) return;
      if (!searchHome) {
        searchHome = document.createComment('km-search-home');
        form.parentNode.insertBefore(searchHome, form);
      }
      strip.insertBefore(form, strip.querySelector('.km-compact-cart'));
      document.documentElement.classList.add('km-search-in-strip');
    } else if (searchHome && searchHome.parentNode && form.parentNode === strip) {
      searchHome.parentNode.insertBefore(form, searchHome);
      document.documentElement.classList.remove('km-search-in-strip');
    }
  }
  mobile.addEventListener('change', placeSearch);

  // The theme's live search listens for keyup only; phone keyboards (predictive text, autocorrect,
  // swipe typing, picking a suggestion) often change the text without one, so pass text changes on
  var keyupTimer = null;
  document.addEventListener('input', function(e) {
    if (!e.target || e.target.id !== 'search_main') return;
    clearTimeout(keyupTimer);
    keyupTimer = setTimeout(function() {
      e.target.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Unidentified' }));
    }, 150);
  });

  // Phones: the header collapses to one row (delivery line + menu · search · cart) once the page
  // is scrolled; km-mobile-nav.css animates it from .header--compact. Expands again near the top.
  var phone = window.matchMedia('(max-width: 749px)');
  var compact = false;
  var compactTicking = false;
  function setCompact(on) {
    var header = document.getElementById('header-outer');
    if (!header || on === compact) return;
    compact = on;
    header.classList.toggle('header--compact', on);
    // Only reachable (keyboard / screen readers) while showing; the logo row has the same links
    Array.prototype.forEach.call(header.querySelectorAll('.km-compact-btn'), function(btn) {
      if (on) {
        btn.removeAttribute('tabindex');
        btn.removeAttribute('aria-hidden');
      } else {
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-hidden', 'true');
      }
    });
  }
  function checkCompact() {
    compactTicking = false;
    if (!phone.matches) return setCompact(false);
    var y = window.scrollY || window.pageYOffset || 0;
    // The page keeps the full header's space at the top, and the compact header is 82px shorter
    // (logo row 44 + delivery card 34 + top padding 4). Collapse once that space has scrolled away
    // and expand as soon as it comes back, so no blank band shows under the compact header.
    // A little hysteresis keeps it from flickering at the edge.
    if (y > 90) setCompact(true);
    else if (y < 82) setCompact(false);
  }
  window.addEventListener('scroll', function() {
    if (compactTicking) return;
    compactTicking = true;
    window.requestAnimationFrame(checkCompact);
  }, { passive: true });
  phone.addEventListener('change', checkCompact);
  // the browser may restore the scroll position after load (back/forward, refresh)
  window.addEventListener('pageshow', checkCompact);

  // The compact cart uses the header cart's icon and count, and opens the same cart drawer
  function setupCompactCart() {
    var link = document.querySelector('[data-km-compact-cart]');
    var source = document.querySelector('#header-inner li.cart > a');
    if (!link || !source || link.firstChild) return;
    var icon = source.querySelector('i');
    if (icon) link.appendChild(icon.cloneNode(true));
    var count = link.querySelector('.cart-count');
    var sourceCount = source.querySelector('.cart-count');
    if (count && sourceCount) {
      new MutationObserver(function() {
        count.textContent = sourceCount.textContent;
        count.className = sourceCount.className;
      }).observe(sourceCount, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    link.addEventListener('click', function(e) {
      e.preventDefault();
      source.click();
    });
  }

  function init() {
    setupCompactCart();
    checkCompact();
    placeSearch();
    buildCategoryGrid();
    fillShipZip();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
